import { RootState } from "app.store";
import * as React from "react";
import "./loading.less";
import clsx from "clsx";
import { useAppSelector } from "app.hook";
import { shallowEqual } from "react-redux";
export function Loading(props: any) {
  const isLoading = useAppSelector(
    (state: RootState) => state.globalValue.isLoading,
    shallowEqual
  );
  const preLoadingApp = useAppSelector(
    (state: RootState) => state.globalValue.preLoadingApp,
    shallowEqual
  );
  return (
    <div className={clsx((isLoading || preLoadingApp) && `Backdrop`)}>
      <div className={`Loader`}>
        <div className="Loader-inner"></div>
      </div>
    </div>
  );
}
